import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
export default WithPluginState;